<template>
  <CareTypeCardGroup
    v-if="!isLoading"
    :careTypes="careTypes"
    :headingText="'What type of care do you currently need?'"
    @select="saveCareType"
  />
</template>

<script lang="ts">
import { sendBrazeEvent } from '../../../lib/braze';
import { redirect } from '@/helpers/redirects';
import { CareType } from '@/types/care_type';
import CareTypeCardGroup from '@/components/careType/CareTypeCardGroup.vue';
import { sendSegmentEventWithTimeout } from '../../../lib/segment';
import OnboardingMutations from '../../../graphql/onboarding/mutations';
import { BASIC_REGISTRATION_CARE_TYPE_LOADED } from '@/lib/constants/braze_custom_events';
import { redirectToJobPost } from '@/helpers/jobPostRedirect';

export default {
  name: 'CareTypeForm',
  components: {
    CareTypeCardGroup,
  },
  props: {
    useNewJobPost: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      selectedCareType: '',
    };
  },
  computed: {
    careTypes(): string[] {
      return ['CHILD_CARE', 'COMPANION_CARE', 'PET_CARE', 'SPECIAL_NEEDS'];
    },
  },
  mounted() {
    sendBrazeEvent(BASIC_REGISTRATION_CARE_TYPE_LOADED);
  },
  methods: {
    async saveCareType(careType: CareType | 'CHILD_CARE') {
      this.selectedCareType = careType;
      try {
        await this.$apollo.mutate({
          mutation: OnboardingMutations.COMPLETE_CARE_TYPE_TASK,
          variables: { careType: this.selectedCareType === 'CHILD_CARE' ? 'BABYSITTER' : this.selectedCareType },
        });
        await sendSegmentEventWithTimeout('Care Type Selected', { care_type: this.selectedCareType });
        redirectToJobPost(this.selectedCareType as CareType | 'CHILD_CARE', this.$router, { source: 'registration' });
      } catch (_error) {
        this.handleError();
      }
    },
    handleError() {
      redirect('/something-went-wrong?retry=true');
    },
  },
};
</script>
